import actions from '../actions/actionNames';
import initialState from '../initialState';

const editUserRoles = (state = initialState.editUserRoles, action) => {
  const { payload } = action;

  switch (action.type) {
    case actions.UPDATE_ASSIGNED_ROLES:
      return {
        ...state,
        roles: payload
      };
    case actions.CLEAR_ASSIGNED_ROLES: {
      return {
        ...state,
        roles: []
      };
    }
    default:
      return state;
  }
};

export default editUserRoles;
